import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Big from 'big.js';
import { Modal, Table } from 'antd';

import { queryIncCustomIncomeUnconfirm } from '@api/incubator/custom';

class ModalMatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTips: false,
      incomeList: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    this.getIncCustomIncomeUnconfirm();
  }

  /**
   * 同一公司下的资金流水
   */
  getIncCustomIncomeUnconfirm = current => {
    const { incomeTarget } = this.props;
    queryIncCustomIncomeUnconfirm({
      customUuid: this.props.customUuid,
      incubatorUuid: this.props.incubatorUuid,
      incomeTarget,
      limit: 5,
      start: current || 1,
    }).then(res => {
      this.setState({
        incomeList: {
          list: res.data,
          pagination: {
            current: current || 1,
            pageSize: 5,
            total: res.totalSize,
          },
        },
      });
    });
  };

  handleSubmit = e => {
    if (this.incomeUuid) {
      this.props.onOk({ incomeUuid: this.incomeUuid });
    } else {
      this.setState({
        showTips: true,
      });
    }
  };

  findTypeName = record => {
    let typeName = '';
    const { expendType, incomeType } = this.props;
    const type = record.target === 0 ? expendType : incomeType;
    type.forEach(item => {
      if (record.type === item.value) {
        typeName = item.key;
      }
    });

    return typeName;
  };

  onSelect = (record, selected) => {
    this.incomeUuid = record.uuid;
  };

  onTableChange = pagination => {
    this.getIncCustomIncomeUnconfirm(pagination.current);
  };

  columns = () => {
    return [
      {
        title: '日期',
        dataIndex: 'date',
        width: 100,
        render: text => (
          <span className="time">{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '类目',
        dataIndex: 'type',
        width: 100,
        render: (text, record) => <span className="type">{this.findTypeName(record)}</span>,
      },
      {
        title: '收支类型',
        dataIndex: 'target',
        width: 100,
        render: (text, record) => <span>{text === 0 ? '支出' : '收入'}</span>,
      },
      {
        title: '可匹配金额',
        dataIndex: 'money',
        width: 130,
        render: (text, record) => {
          const money = (
            new Big(record.money || 0) - new Big(Math.abs(record.confirm || 0))
          ).toFixed(2);
          return <span>{money}</span>;
        },
      },
      {
        title: '备注',
        dataIndex: 'remark',
        width: 200,
      },
    ];
  };

  render() {
    const {
      incomeList: { list, pagination },
    } = this.state;
    const rowSelection = {
      type: 'radio',
      onSelect: this.onSelect,
    };
    const { showTips } = this.state;
    return (
      <Modal
        visible
        title="匹配流水"
        onCancel={this.props.onCancel}
        width={650}
        onOk={this.handleSubmit}
      >
        <Table
          dataSource={list}
          columns={this.columns()}
          rowKey="uuid"
          pagination={pagination}
          rowSelection={rowSelection}
          onChange={this.onTableChange}
        />
        {showTips ? <span style={{ color: 'red' }}>请选择一条资金流水</span> : null}
      </Modal>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  incomeType: state.income_type,
}))(ModalMatch);



// WEBPACK FOOTER //
// ./src/components/incubator/bill/detail/ModalMatch.js